import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import './SongsPage.scss';
import FuntoneButton from '../../Components/FuntoneButton/FuntoneButton';
import {
  setCurrentScreen,
  ScreensEnum,
  getCatalog,
  setSelectedGenre,
  saveToHistory,
  setIsGalleryMode,
  setIsEditPlaylistFlow,
  setIsChangeDefaultSongFlow,
  setIsAssignToContactFlow,
  setDefaultSong,
  getSubscribersData,
  showToast,
  setSelectedSong,
} from '../../FuntoneSlice';
import { isMobile } from 'react-device-detect';
import mobileVector from './images/mobile-vector.svg';
import desktopVector from './images/desktop-vector.svg';
import { useScreenNavigation } from '../../Utils/ScreenNavigationUtils';
import { useSongsPageData } from './hooks/useSongsPageData';
import { useChangeDefaultSong } from './hooks/useChangeDefaultSong';
import { createHandleSubmitDefaultSong } from './handlers/defaultSongHandler';
import { SongsContent } from './components/SongsContent';
import { getPageTitle, getHeroBackgroundStyle, getPageClassName, getEmptyStates } from './helpers/pageHelpers';
import Config from 'app/Config';


const SongsPage = (props) => {
  const {
    selectedGenre,
    selectedGenreSongs,
    catagories,
    isGalleryMode,
    subscriberGallery,
    selectedSubscriber,
    isEditPlaylistFlow,
    isChangeDefaultSongFlow,
    isAssignToContactFlow,
  } = props.funtoneSlice;

  const dispatch = useDispatch();
  const contentRef = useRef(null);
  const { navigateToCatalog, navigateToSongSettings } = useScreenNavigation();

  // Custom hooks for data and change-default logic
  const { songs, isLoading } = useSongsPageData({
    isChangeDefaultSongFlow,
    isEditPlaylistFlow,
    isGalleryMode,
    isAssignToContactFlow,
    subscriberGallery,
    selectedGenre,
    selectedGenreSongs,
    catagories,
    getCatalog: props.getCatalog,
    setSelectedGenre: props.setSelectedGenre,
  });

  const { selectedSongId, setSelectedSongId, isButtonSticky } = useChangeDefaultSong({
    isChangeDefaultSongFlow,
    subscriberGallery,
    songs,
    contentRef,
  });

  // Clean up modes when leaving - but NOT flow flags that persist to SongSettings
  useEffect(() => {
    return () => {
      // Only clear isGalleryMode - it's a view-only mode that doesn't continue to other screens
      if (isGalleryMode) dispatch(setIsGalleryMode(false));
      // Note: isEditPlaylistFlow, isChangeDefaultSongFlow, and isAssignToContactFlow are NOT cleared here
      // They persist between SongsPage and SongSettings
      // They're cleared via goBack reducer when returning to AdminPanel from SongsPage
    };
  }, [isGalleryMode, dispatch]);

  // Handlers
  const handleSubmitDefaultSong = createHandleSubmitDefaultSong({
    selectedSongId,
    selectedSubscriber,
    subscriberGallery,
    dispatch,
    showToast,
    setDefaultSong,
    getSubscribersData,
    setIsChangeDefaultSongFlow,
    setCurrentScreen: props.setCurrentScreen,
    ScreensEnum,
    loginData: props.loginData,
  });

  const handleSongClick = (song) => {
    // TODO: Handle song selection/download
  };

  const handlePlayClick = (song) => {
    // TODO: Handle play functionality
  };

  const handleDownloadClick = (song) => {
    // TODO: Handle download functionality
  };

  const handleSubmitAssignToContactFlow = () => {
    if (!selectedSongId) {
      dispatch(showToast({ message: 'אנא בחרו שיר', type: 'error' }));
      return;
    }

    const selectedSong = songs.find((song) => song.id === selectedSongId);
    if (selectedSong) {
      dispatch(setSelectedSong(selectedSong));
      navigateToSongSettings();
    }
  };
  // Compute derived values
  const { showEmptyChangeDefaultMessage, showEmptyPlaylistMessage } = getEmptyStates({
    isChangeDefaultSongFlow,
    isEditPlaylistFlow,
    songs,
  });

  const pageTitle = getPageTitle({ isChangeDefaultSongFlow, isEditPlaylistFlow, isGalleryMode, selectedGenre, isAssignToContactFlow });
  const myPlaylistHeroImage = Config.epiBaseUrl + props.contentData?.myPlaylistHeroImage?.value?.url || null;
  const heroBackgroundStyle = getHeroBackgroundStyle({ isGalleryMode, isEditPlaylistFlow, isChangeDefaultSongFlow, selectedGenre, myPlaylistHeroImage });
  const pageClassName = getPageClassName({ isGalleryMode, isEditPlaylistFlow, isChangeDefaultSongFlow, isAssignToContactFlow });

  console.log(myPlaylistHeroImage);
  console.log(props);
  return (
    <div className={pageClassName}>
      {!isAssignToContactFlow && <div className='hero-section'>
        <div className='hero-background' style={heroBackgroundStyle}>
          <Image src={isMobile ? mobileVector : desktopVector} className='hero-vector' />
        </div>
      </div>}
      <div className='hero-title-container'>
        <h1 className='hero-title'>{pageTitle}</h1>
        {isGalleryMode && selectedSubscriber && (
          <div className='hero-subtitle'>
            בניגון רנדומלי
          </div>
        )}
      </div>
      <div className='songs-content' ref={contentRef}>
        <SongsContent
          isChangeDefaultSongFlow={isChangeDefaultSongFlow}
          isEditPlaylistFlow={isEditPlaylistFlow}
          isAssignToContactFlow={isAssignToContactFlow}
          showEmptyChangeDefaultMessage={showEmptyChangeDefaultMessage}
          showEmptyPlaylistMessage={showEmptyPlaylistMessage}
          songs={songs}
          selectedSongId={selectedSongId}
          onSongSelect={setSelectedSongId}
          onSongClick={handleSongClick}
          onPlayClick={handlePlayClick}
          onDownloadClick={handleDownloadClick}
          isLoading={isLoading}
        />
      </div>
      {(isChangeDefaultSongFlow || isAssignToContactFlow) && (
        <div className={`submit-button-container ${isButtonSticky ? 'sticky-bottom' : ''}`}>
          <FuntoneButton variant='text' text='לא מצאתם שיר מתאים? לקטלוג השירים' onClick={navigateToCatalog} />
          <FuntoneButton variant='primary' text='בחרתי, אפשר להמשיך' onClick={isAssignToContactFlow ? handleSubmitAssignToContactFlow : handleSubmitDefaultSong} />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    funtoneSlice: state.FuntoneSlice,
    loginData: state.authentication.loginData,
  };
};

const mapDispatchToProps = {
  setCurrentScreen,
  getCatalog,
  setSelectedGenre,
};

export default connect(mapStateToProps, mapDispatchToProps)(SongsPage);
